import { RootState } from '../store';

export const selectGlobalAlertReducer = ({ globalAlertReducer }: RootState) => globalAlertReducer;
